import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link, useNavigate } from "react-router-dom";

import {
  auth,
  registerWithEmailAndPassword,
} from "../Firebase/Firebase";

import "./Register.sass";

function Register() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [organization, setOrganization] = useState("");
  const [industry, setIndustry] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [user, loading, error] = useAuthState(auth);

  const navigate = useNavigate();
  const register = async () => {
    if (!firstName) alert("Please enter first name");
    if (!lastName) alert("Please enter last name");
    if (!email) alert("Please enter email");
    if (!password) alert("Please enter password");
    if (password !== rePassword) alert ("Passwords must match");

    try{
      setDisabled(true);
      await registerWithEmailAndPassword(firstName, lastName, email, password);
      navigate("/home");
    }
    catch (err) {
      alert("Error registering");
      setDisabled(false);
    }
  };

  useEffect(() => {
    if (loading) return;
    if (user) navigate("/home");
  }, [user, loading]);

  return (
    <div className="register">
      <div className="Regsiter-title">Hume AI</div>
      <div className="Register">
        <input
          type="text"
          className="Common-text-field Register-text-field"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          placeholder="First Name"
        />
        <input
          type="text"
          className="Common-text-field Register-text-field"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          placeholder="Last Name"
        />
        <input
          type="text"
          className="Common-text-field Register-text-field"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="E-mail Address"
        />
        <input
          type="password"
          className="Common-text-field Register-text-field"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
        />
        <input
          type="password"
          className="Common-text-field Register-text-field"
          value={rePassword}
          onChange={(e) => setRePassword(e.target.value)}
          placeholder="Re-Enter Password"
        />
        <button className="Common-button Register-button" onClick={register} disabled={disabled}>
          Register
        </button>
        <div>
          Already have an account? <Link to="/">Login</Link> now.
        </div>
      </div>
    </div>
  );
}

export default Register;
